import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'panel'];

  connect() {
    this.activate(
      this.tabTargets.find(
        (tab) => tab.getAttribute('aria-selected') === 'true',
      ) || this.tabTargets[0],
    );
  }

  select(event) {
    const tab = event.target.closest('[role="tab"]');
    if (!tab || !this.tabTargets.includes(tab)) return;

    event.preventDefault();
    this.activate(tab);
  }

  keydown(event) {
    const tabs = this.tabTargets;
    const index = tabs.indexOf(event.target);
    if (index < 0) return;

    let next;
    switch (event.key) {
      case 'ArrowRight':
        next = (index + 1) % tabs.length;
        break;
      case 'ArrowLeft':
        next = (index - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activate(tabs[next]);
    tabs[next].focus();
  }

  activate(selected) {
    if (!selected) return;

    this.tabTargets.forEach((tab) => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', active);
      tab.tabIndex = active ? 0 : -1;
    });

    const panelId = selected.getAttribute('aria-controls');
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  }
}
